import {ekadasi} from "../../constants/ekadasi-list";
import {useTranslation} from "react-i18next";
import styles from "./EkadashiListV2.module.scss";
import {useNavigate} from "react-router-dom";

function EkadashiListV2() {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();

    return (<div className={styles.container}>
        <div className={styles.titleContainer}>
            <img src={"/images/moon_set.png"}></img>
            <div>{t("Profile.EkadashiList")}</div>
            <img src={"/images/moon_rise.png"}></img>
        </div>
        <div className={styles.subcontainer}>
        <div className={styles.col}>
                <div className={styles.moons}>
                    <img src={`/locales/${i18n.language}/images/moons-set-v2.png`} alt={"moons"}/>
                </div>
                <div className={styles.subcol}>
                    {ekadasi.map((item, index) => (
                        index % 2 === 0 && (
                            <div key={index} className={styles.ekadashi}
                                 onClick={() => window.open(
                                     "/locales/" + i18n.language + "/PDF/Ekadashi/014-" +
                                     ((index + 1) < 10 ? "0" : "") + (index + 1) + ".pdf", "_blank"
                                 )}>
                                <div className={styles.index}>{((index + 1) < 10 ? "0" : "") + (index + 1)}</div>
                                <div className={styles.name}>{t("Ekadasi." + item)}</div>
                            </div>
                        )
                    ))}
                </div>
            </div>

            <div className={styles.col}>
                <div className={styles.subcol}>
                    {ekadasi.map((item, index) => (
                        index % 2 === 1 && (
                            <div key={index} className={styles.ekadashi}
                                 onClick={() => window.open(
                                     "/locales/" + i18n.language + "/PDF/Ekadashi/014-" +
                                     ((index + 1) < 10 ? "0" : "") + (index + 1) + ".pdf", "_blank"
                                 )}>
                                <div className={styles.index}>{((index + 1) < 10 ? "0" : "") + (index + 1)}</div>
                                <div className={styles.name}>{t("Ekadasi." + item)}</div>
                            </div>
                        )
                    ))}
                </div>
                <div className={styles.moons}>
                    <img src={`/locales/${i18n.language}/images/moons-rise-v2.png`} alt={"moons"}/>
                </div>
            </div>
        </div>
    </div>);
}

export default EkadashiListV2;